<template>
  <b-container fluid>
    <b-row>
        <b-col class="mb-4 mt-3">
            <h4><b-icon icon="credit-card-fill"/> Configuración <b-badge @click="iniciarLLave()" variant="secondary" style="cursor:pointer">Inicializar llave <b-icon icon="key" rotate="135"/> <b-spinner v-if="procesando" small/></b-badge></h4>
        </b-col>
    </b-row>
    <b-row>
        <b-col class="mt-3" cols="6"><h6>HOST</h6><b-form-input v-model="config.IP"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>PwdCertificado</h6><b-form-input v-model="config.PwdCertificado"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>TIMEOUT</h6><b-form-input v-model="config.TIMEOUT"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>Company</h6><b-form-input v-model="config.Company"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>NEGOCIO1</h6><b-form-input v-model="config.NEGOCIO1"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>TERMINAL1</h6><b-form-input v-model="config.TERMINAL1"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>NEGOCIO2</h6><b-form-input v-model="config.NEGOCIO2"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>TERMINAL2</h6><b-form-input v-model="config.TERMINAL2"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>PUERTOCOM</h6><b-form-input v-model="config.PUERTOCOM"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>CASHBACK</h6><b-form-checkbox checked-value="1" unchecked-value="0" v-model="config.CASHBACK"></b-form-checkbox></b-col>
        <b-col class="mt-3" cols="3"><h6>SOCKETIP</h6><b-form-input v-model="config.SOCKETIP"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>SOCKETPORT</h6><b-form-input v-model="config.SOCKETPORT"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>HTTP_ADDRESS</h6><b-form-input v-model="config.HTTP_ADDRESS"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>HTTP_PORT</h6><b-form-input v-model="config.HTTP_PORT"></b-form-input></b-col>
        <b-col class="mt-3" cols="3"><h6>Hab_TLV</h6><b-form-checkbox checked-value="1" unchecked-value="0" v-model="config.Hab_TLV"></b-form-checkbox></b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col cols="6"><b-button @click="leerConfigRelayMultipay" block variant="info" size="lg">Leer <b-icon icon="download"/></b-button></b-col>
      <b-col cols="6"><b-button @click="guardarConfigRelayMultipay" block variant="success" size="lg">Guardar <b-icon icon="upload"/></b-button></b-col>
    </b-row>
    <b-row>
      <b-col class="mt-5"><b-button  @click="noConfirm">NO CONFIRM</b-button></b-col>
    </b-row>
  </b-container>
</template>


<script>

import axios from 'axios'
import { server, getPostConfigTimeOut} from '@/axios-tools'

export default {
  props: ['timeout'],
  

  data(){
    return{
      
      config:{
          IP:"",
          PwdCertificado:"",
          TIMEOUT:"",
          Company:"",
          NEGOCIO1:"",
          TERMINAL1:"",
          NEGOCIO2:"",
          TERMINAL2:"",
          PUERTOCOM:"",
          CASHBACK:"0",
          SOCKETIP:"",
          SOCKETPORT:"",
          HTTP_ADDRESS:"",
          HTTP_PORT:"",
          Hab_TLV:"",
      },

      procesando : false
          

    }
  },
  components: {
  },
  methods:{
    iniciarLLave(){
      this.procesando = true;
      axios(
        getPostConfigTimeOut(server.cobroPinpad, {"adq" : 'evop', action:"INICIAR_LLAVE"}, null, {}, this.timeout)        
       )
      .then((res) => {
        this.procesando = false;

        let esObjeto = typeof res.data == 'object';
        let resPinpad = esObjeto ? res.data.status : res;


        alert(resPinpad);

      }).catch(err => {
          this.procesando = false;
          alert(err);
      });
    },
    loadDefaultValuesRelayMp(){
        this.IP="https://ic2.multipay.mx:38263/Token//M1M5/Payments/Authorize/5.6.9/&";
        this.PwdCertificado="";
        this.TIMEOUT="40000";
        this.Company="";
        this.NEGOCIO1="";
        this.TERMINAL1="";
        this.NEGOCIO2="";
        this.TERMINAL2="";
        this.PUERTOCOM="COM9";
        this.CASHBACK="0";
        this.SOCKETIP="127.0.0.1";
        this.SOCKETPORT="11000";
        this.HTTP_ADDRESS="localhost";
        this.HTTP_PORT="8088";
        this.Hab_TLV="0";
    },
    leerConfigRelayMultipay(){
      
      axios(
        getPostConfigTimeOut(server.cobroPinpad, {action:"SHOWCONFIG"}, null, {}, this.timeout)        
       )
      .then(res => {
        let resMultipay = res.data;
        resMultipay = resMultipay.replace("|Respuesta=", "").replace("|dcs_form=SHOWCONF|", "").replace("|","");
        let arr = resMultipay.split("&");
        for(let idx in arr){
          let name = arr[idx].split("=")[0];
          let value = arr[idx].split("=")[1];
          this.config[name] = value;
        }
        alert("Configuración Leida");
      }).catch(err => {
          alert(err);
      });
    },
    guardarConfigRelayMultipay(){
      
      let trama = 
      "HOST="+this.config.IP+"|"+
      "TIMEOUT="+this.config.TIMEOUT+"|"+
      "mer_id="+this.config.NEGOCIO1+"|"+
      "ter_id="+this.config.TERMINAL1+"|"+
      "merUSD_id="+this.config.NEGOCIO2+"|"+
      "terUSD_id="+this.config.TERMINAL2+"|"+
      "puertoCom="+this.config.PUERTOCOM+"|"+
      "socketIp="+this.config.SOCKETIP+"|"+
      "socketPort="+this.config.SOCKETPORT+"|"+
      "http_address="+this.config.HTTP_ADDRESS+"|"+
      "http_port="+this.config.HTTP_PORT+"|"+
      "PwdCertificado="+this.config.PwdCertificado+"|"+
      "Hab_TLV="+this.config.Hab_TLV+"|"+
      "Company="+this.config.Company;
      
      
      axios(
        getPostConfigTimeOut(server.cobroPinpad, {action:"SAVECONFIG", concepto:trama}, null, {}, this.timeout)        
       )
      .then(() => {
        //let resMultipay = res.data;
        alert("Configuracion cargada");

      }).catch(err => {
          alert(err);
      });
    },
    noConfirm(){
      
      axios(
        getPostConfigTimeOut(server.cobroPinpad, {action:"NO_CONFIRM"}, null, {}, this.timeout)        
       )
      .then(res => {
        
        alert("---"+res.data);
      }).catch(err => {
          alert(err);
      });
    },

  },
   
  
}

</script>
<style>
  
</style>